export const progress = {
  baseStyle: {
    track: {
      bg: "background.grey",
    },
    filledTrack: {
      bg: "text.light.grey", 
    },
  }
};